<div class="flex justify-content-between align-items-center gap-2">
  <div class="flex flex-column">
    <label class="text-light">
      <ng-content></ng-content>
    </label>
  </div>
  <p-fileUpload
    mode="basic"
    [customUpload]="true"
    [chooseLabel]="'PD_COLLECT_DATA.LABEL.UPLOAD' | translate"
    chooseIcon="pi pi-upload"
    styleClass="p-button-rounded gap-2"
    accept="image/png, image/jpeg, document/pdf"
    [disabled]="blocked"
    (onSelect)="onFileSelected()"
    (uploadHandler)="clearFiles()"
    [maxFileSize]="1000000"
  ></p-fileUpload>
</div>
